import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=5d21a0d6&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=5d21a0d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21a0d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d21a0d6')) {
      api.createRecord('5d21a0d6', component.options)
    } else {
      api.reload('5d21a0d6', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=5d21a0d6&scoped=true", function () {
      api.rerender('5d21a0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/SideMenu.vue"
export default component.exports